export default () => {
	const defaultRoute = () => {
		return "dashboard";
	};

	return {
		defaultRoute,
	};
};
